import React, { useState, useEffect, useCallback } from "react";
// Datatable'ı kaldırdık. Kendi özel tablomuzu kullanacağız.
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import axios from "axios";

export const AdminSubjectList = () => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const navigate = useNavigate();

    // -- State'ler --
    const [courses, setCourses] = useState([]);
    const [allCourseSubjects, setAllCourseSubjects] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [passiveData, setPassiveData] = useState([]);
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");

    // Sayfalama (Pagination) State'leri
    const itemsPerPage = 10;
    const [activePage, setActivePage] = useState(1);
    const [passivePage, setPassivePage] = useState(1);

    // Tümünü Gör State'leri
    const [showAllActive, setShowAllActive] = useState(false);
    const [showAllPassive, setShowAllPassive] = useState(false);

    // -- Yardımcı: HTML Tag'leri Render Etme --
    const renderHtml = (rawHtml) => {
        return <span dangerouslySetInnerHTML={{ __html: rawHtml }} />;
    };

    // -- API: Kurs Listesini Getir --
    const fetchCourses = async () => {
        try {
            const res = await axios.get("https://api.heryerdeingilizce.com/api/admin/CourseManager/GetCourses", {
                headers: { Authorization: `Bearer ${user.token}` }
            });
            if (res.data.success) {
                const activeCourses = res.data.data.filter(c => c.isActive && !c.isDeleted);
                setCourses(activeCourses);
            }
        } catch (err) {
            setMsg("Kurs listesi yüklenemedi.");
        }
    };

    // SortId kontrolü (Çakışma varsa uyarır)
    useEffect(() => {
        if (allCourseSubjects.length > 0) {
            const sortIdMap = {};
            let hasDuplicate = false;
            const duplicatedSortIds = new Set();

            allCourseSubjects.forEach((subject) => {
                if (sortIdMap[subject.sortId]) {
                    hasDuplicate = true;
                    duplicatedSortIds.add(subject.sortId);
                } else {
                    sortIdMap[subject.sortId] = true;
                }
            });

            if (hasDuplicate) {
                Swal.fire({
                    title: "Sıralama (SortId) Çakışması!",
                    text: `Dikkat! Listelenen konular arasında aynı sıra numarasına sahip kayıtlar bulunuyor. Çakışan SortId değerleri: ${[...duplicatedSortIds].join(", ")}. Lütfen verilerin sırasını düzenleyiniz.`,
                    icon: "warning",
                    confirmButtonText: "Tamam"
                });
            }
        }
    }, [allCourseSubjects]);

    // -- API: Seçilen Kursa Göre Konuları (Subjects) Getir --
    const fetchSubjectsByCourse = useCallback(async (courseId) => {
        if (!courseId) return;
        setLoading(true);
        setMsg("");

        try {
            const res = await axios.get(`https://api.heryerdeingilizce.com/api/admin/SubjectManager/GetListByCourse`, {
                params: { id: courseId },
                headers: { Authorization: `Bearer ${user.token}` }
            });

            if (res.data.success) {
                const allData = res.data.data;

                const sortedData = allData
                    .sort((a, b) => a.sortId - b.sortId)
                    .map(item => ({ ...item, originalSortId: item.sortId }));

                setAllCourseSubjects(sortedData);
                setActiveData(sortedData.filter(s => s.isActive && !s.isDeleted));
                setPassiveData(sortedData.filter(s => !s.isActive && !s.isDeleted));

                // Kurs değiştiğinde sayfaları ve görünümleri sıfırla
                setShowAllActive(false);
                setShowAllPassive(false);
                setActivePage(1);
                setPassivePage(1);
            } else {
                setMsg(res.data.message || "Konular getirilirken bir sorun oluştu.");
            }
        } catch (err) {
            setMsg("Konular yüklenirken bir hata oluştu.");
        } finally {
            setLoading(false);
        }
    }, [user.token]);

    useEffect(() => {
        fetchCourses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCourseChange = (e) => {
        const id = e.target.value;
        setSelectedCourseId(id);
        fetchSubjectsByCourse(id);
    };

    // -- MANUEL SORT ID DEĞİŞTİRME (KAYDIRMALI VE DÖNGÜLÜ GÜNCELLEME) --
    const handleManualSortChange = useCallback(async (subject, newSortIdValue) => {
        let newSortId = parseInt(newSortIdValue, 10);

        if (isNaN(newSortId) || newSortId === subject.sortId || newSortId < 1) return;

        let _data = [...allCourseSubjects];

        if (newSortId > _data.length) newSortId = _data.length;

        const oldIndex = _data.findIndex(s => s.id === subject.id);
        if (oldIndex === -1) return;

        const itemToMove = _data.splice(oldIndex, 1)[0];
        _data.splice(newSortId - 1, 0, itemToMove);

        const updatedData = _data.map((item, idx) => ({
            ...item,
            sortId: idx + 1
        }));

        const changedSubjects = updatedData.filter(item => item.sortId !== item.originalSortId);

        if (changedSubjects.length > 0) {
            Swal.fire({
                title: 'Sıralama Güncelleniyor...',
                html: `Lütfen bekleyiniz.<br/><br/><b>0 / ${changedSubjects.length}</b> kayıt güncellendi.`,
                allowOutsideClick: false,
                didOpen: () => { Swal.showLoading(); }
            });

            try {
                let completedCount = 0;
                for (const item of changedSubjects) {
                    const payload = { ...item };
                    delete payload.originalSortId;

                    await axios.post("https://api.heryerdeingilizce.com/api/admin/SubjectManager/Update", payload, {
                        headers: { 'Authorization': 'Bearer ' + user.token }
                    });

                    completedCount++;
                    Swal.update({
                        html: `Lütfen bekleyiniz.<br/><br/><b>${completedCount} / ${changedSubjects.length}</b> kayıt güncellendi.`
                    });
                }

                Swal.fire({ icon: 'success', title: 'Başarılı!', timer: 1000, showConfirmButton: false });
                fetchSubjectsByCourse(selectedCourseId);

            } catch (error) {
                console.error(error);
                Swal.fire("Hata", "Sıralama güncellenirken sunucu kaynaklı bir hata oluştu.", "error");
                fetchSubjectsByCourse(selectedCourseId);
            }
        }
    }, [allCourseSubjects, user.token, selectedCourseId, fetchSubjectsByCourse]);

    // SİLME İŞLEMİ
    const handleDelete = (id) => {
        Swal.fire({
            title: t("are_you_sure") || "Emin misiniz?",
            text: "Bu konuyu silmek istediğinize emin misiniz?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t("yes_delete") || "Evet, Sil",
            cancelButtonText: t("cancel") || "İptal"
        }).then((result) => {
            if (result.isConfirmed) {
                console.log("Silme işlemi ID:", id);
            }
        });
    };

    // --- ÖZEL TABLO RENDER FONKSİYONU ---
    const renderCustomTable = (data, isShowAll, setIsShowAll, currentPage, setCurrentPage) => {
        const totalPages = Math.ceil(data.length / itemsPerPage);

        // Eğer "Tümünü Gör" aktifse datanın tamamını, değilse sadece ilgili sayfanın dilimini göster
        const displayedData = isShowAll
            ? data
            : data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

        return (
            <div>
                <div className="table-responsive">
                    <table className="table table-hover table-bordered bg-white align-middle text-center mb-0">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: "140px" }}>Sıra (SortId)</th>
                                <th>{t('subjectName') || "Konu Adı"}</th>
                                <th>{t('subjectDescription') || "Konu Açıklaması"}</th>
                                <th>{t('isActive') || "Durum"}</th>
                                <th>{t('actions') || "İşlemler"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedData.length > 0 ? displayedData.map(row => (
                                <tr key={row.id}>
                                    <td>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                key={`sortId-${row.id}-${row.sortId}`}
                                                id={`sortId-${row.id}`}
                                                type="number"
                                                defaultValue={row.sortId}
                                                min="1"
                                                className="form-control form-control-sm text-center fw-bold text-danger shadow-sm"
                                                style={{ width: "70px" }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        handleManualSortChange(row, e.target.value);
                                                    }
                                                }}
                                            />
                                            <button
                                                className="btn btn-sm btn-outline-success ms-2 shadow-sm"
                                                onClick={() => {
                                                    const inputVal = document.getElementById(`sortId-${row.id}`).value;
                                                    handleManualSortChange(row, inputVal);
                                                }}
                                                title="Güncelle"
                                            >
                                                <i className="fa fa-check"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <td className="text-start">{renderHtml(row.subjectName)}</td>
                                    <td className="text-start">{row.subjectDesc}</td>
                                    <td>
                                        <span className={`badge ${row.isActive ? 'bg-success' : 'bg-secondary'}`}>
                                            {row.isActive ? "✅ Aktif" : "❌ Pasif"}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="btn-group shadow-sm">
                                            <button className="btn btn-warning btn-sm" onClick={() => navigate(`/admin/editsubject/${row.id}`)}>
                                                <i className="fa fa-edit"></i> {t('edit') || "Düzenle"}
                                            </button>
                                            <button className="btn btn-primary btn-sm" onClick={() => navigate(`/admin/questionlistbysubject/${row.id}`)}>
                                                <i className="fa fa-list"></i> {t('questions') || "Sorular"}
                                            </button>
                                            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.id)}>
                                                <i className="fa fa-trash"></i> {t('delete') || "Sil"}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="text-muted py-4">Kayıt bulunamadı.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Alt Kısım Kontrolleri: Pagination ve Tümünü Gör Butonu */}
                {data.length > itemsPerPage && (
                    <div className="d-flex justify-content-between align-items-center p-3 bg-light border-top">
                        {/* Pagination: Eğer Tümünü Gör aktif DEĞİLSE göster */}
                        {!isShowAll ? (
                            <nav>
                                <ul className="pagination pagination-sm mb-0 shadow-sm">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                                            Önceki
                                        </button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
                                            Sonraki
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        ) : (
                            <div className="text-muted small">Tüm kayıtlar listeleniyor.</div>
                        )}

                        {/* Tümünü Gör / Daralt Butonu */}
                        <button
                            className="btn btn-outline-primary btn-sm shadow-sm fw-bold"
                            onClick={() => setIsShowAll(!isShowAll)}
                        >
                            {isShowAll ? (
                                <><i className="fa fa-compress me-1"></i> Sayfalamaya Dön (10 Kayıt)</>
                            ) : (
                                <><i className="fa fa-list me-1"></i> Tümünü Alt Alta Göster ({data.length})</>
                            )}
                        </button>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="container-fluid py-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
            <div className="row justify-content-center">
                <div className="col-12 col-xl-11">

                    {/* Başlık Kartı ve Filtreleme */}
                    <div className="card shadow-sm border-0 mb-4 bg-white">
                        <div className="card-body p-4 text-center">
                            <h2 className="fw-bold text-primary mb-2">
                                <i className="fas fa-book-open me-2"></i>
                                {t("subjectList") || "Konu Listesi"}
                            </h2>
                            {msg && <div className="alert alert-danger shadow-sm">{msg}</div>}

                            <div className="row justify-content-center mt-4">
                                <div className="col-md-8 col-lg-6">
                                    <label className="form-label fw-bold text-secondary">Bağlı Olduğu Kursu Seçiniz</label>
                                    <select
                                        className="form-select form-select-lg shadow-sm"
                                        value={selectedCourseId}
                                        onChange={handleCourseChange}
                                        style={{ borderLeft: "5px solid #0d6efd" }}
                                    >
                                        <option value="">--- Kurs Seçin ---</option>
                                        {courses.map(course => (
                                            <option key={course.id} value={course.id}>
                                                {course.courseName.replace(/<\/?[^>]+(>|$)/g, "")}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Yükleniyor Animasyonu */}
                    {loading ? (
                        <div className="text-center my-5 py-5">
                            <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status"></div>
                            <p className="mt-3 fw-bold text-secondary">Konular Yükleniyor...</p>
                        </div>
                    ) : (
                        selectedCourseId && (
                            <div className="fade-in">
                                {/* Aktif Konular Kartı */}
                                <div className="card shadow-sm border-0 mb-5 overflow-hidden">
                                    <div className="card-header bg-success text-white py-3">
                                        <h5 className="mb-0 fw-bold">
                                            <i className="fas fa-check-circle me-2"></i> {t("subjectList") || "Aktif Konular"}
                                            <span className="badge bg-light text-success ms-2">{activeData.length}</span>
                                        </h5>
                                    </div>
                                    <div className="card-body p-0">
                                        {renderCustomTable(activeData, showAllActive, setShowAllActive, activePage, setActivePage)}
                                    </div>
                                </div>

                                {/* Pasif Konular Kartı */}
                                <div className="card shadow-sm border-0 bg-light mb-5 overflow-hidden">
                                    <div className="card-header py-3" style={{ backgroundColor: "#6c757d", color: "white" }}>
                                        <h5 className="mb-0 fw-bold">
                                            <i className="fas fa-archive me-2"></i> {t("passivesubjectList") || "Pasif Konular"}
                                            <span className="badge bg-light text-secondary ms-2">{passiveData.length}</span>
                                        </h5>
                                    </div>
                                    <div className="card-body p-0">
                                        {renderCustomTable(passiveData, showAllPassive, setShowAllPassive, passivePage, setPassivePage)}
                                    </div>
                                </div>
                            </div>
                        )
                    )}

                    {/* Boş Durum */}
                    {!selectedCourseId && !loading && (
                        <div className="alert alert-info text-center shadow-sm py-4 border-0" style={{ backgroundColor: "#e9f2ff", color: "#084298" }}>
                            <i className="fa fa-arrow-up d-block mb-3 fs-2"></i>
                            Konuları listelemek için lütfen yukarıdan bir <strong>Kurs</strong> seçiniz.
                        </div>
                    )}

                </div>
            </div>

            {/* Mobil Uyumlu Animasyon ve Stiller */}
            <style jsx>{`
                .fade-in {
                    animation: fadeIn 0.5s ease-in;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(15px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @media (max-width: 768px) {
                    .btn-sm { padding: 0.3rem 0.5rem; font-size: 0.8rem; }
                    .btn-group { display: flex; flex-direction: column; gap: 5px; }
                    .btn-group .btn { border-radius: 4px !important; width: 100%; }
                }
            `}</style>
        </div>
    );
};

export default AdminSubjectList;